import React, { FC, PropsWithChildren } from 'react'
import Head from 'next/head'
import { IMeta } from '@shared/types'
import { getBreadcrumbJson, getProductJson, getRandomReviewCount } from '@shared/config/meta'

export const Meta: FC<PropsWithChildren<IMeta>> = ({
  title,
  description,
  h1,
  id,
  ogTitle,
  ogDescription,
  ogSitename,
  ogImage,
  ogUrl,
  children,
}) => (
  <>
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && (
        <>
          <meta property="og:description" content={ogDescription} />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="ru_RU" />
        </>
      )}
      {ogSitename && <meta property="og:site_name" content={ogSitename} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      {ogUrl !== 'https://payment.mts.ru/cyber' && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: getBreadcrumbJson({ h1 }) }} />
      )}
      {ogUrl !== 'https://payment.mts.ru/cyber' && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: getProductJson({ title, description, id, reviewCount: getRandomReviewCount() }),
          }}
        />
      )}
    </Head>
    {children}
  </>
)
